import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup } from "effect/unstable/httpapi";
import { StationTagHttpErrorResponses } from "../errors/http.ts";
import { StationTagCompareQuery, StationTagCompareResponse, StationTagCreateBody, StationTagCreateResponse,
  StationTagDeleteResponse, StationTagListResponse, StationTagReadResponse, StationTagRestoreBody,
  StationTagRestoreResponse } from "./station.ts";

const collection = "/api/history/workerstations/:stationId/tags";
const station = Schema.Struct({ stationId: Schema.String });
const tag = Schema.Struct({ stationId: Schema.String, name: Schema.String });

export const StationTagApi = HttpApiGroup.make("stationTags").add(
  HttpApiEndpoint.get("list", collection, { params: station, success: StationTagListResponse, error: StationTagHttpErrorResponses }),
  HttpApiEndpoint.post("create", collection, { params: station, payload: StationTagCreateBody,
    success: StationTagCreateResponse.annotate({ httpApiStatus: 201 }), error: StationTagHttpErrorResponses }),
  HttpApiEndpoint.get("compare", `${collection}/compare`, { params: station, query: StationTagCompareQuery,
    success: StationTagCompareResponse, error: StationTagHttpErrorResponses }),
  HttpApiEndpoint.get("read", `${collection}/:name`, { params: tag, success: StationTagReadResponse, error: StationTagHttpErrorResponses }),
  HttpApiEndpoint.delete("delete", `${collection}/:name`, { params: tag, success: StationTagDeleteResponse, error: StationTagHttpErrorResponses }),
  HttpApiEndpoint.post("restore", `${collection}/:name/restore`, { params: tag, payload: StationTagRestoreBody,
    success: StationTagRestoreResponse, error: StationTagHttpErrorResponses })
);
